import React from "react";
import { Button, Modal, Statistic } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import { authAxios } from "../../utils/session_utils";
const { Countdown } = Statistic;


const AmagiCloudPortRefreshDataButton: React.FC = () => {
	return (
		<Button
			type="default"
			icon={<CloseCircleOutlined />}
			onClick={() => {
				Modal.confirm({
					title: "Amagi Cloud-Port - Refresh Data",
					content:
						"Are you sure you want trigger refresh? This will purge data associated with amagi cloud port feeds and recreate them.",
					okText: "Yes",
					cancelText: "No",
					onOk: async () => {
						try {
							// Call the initial REST API
							const response = await authAxios({
								method: "GET",
								url: `${process.env.REACT_APP_BACK_END_API}/scheduling/amagi-segments/refresh-feeds`,
							});
							const data = await response.data;
							console.log("Data fetched successfully:", data);
							// Prepare progress tracking
							const totalRows = data.feeds.length;
							let completedRows = 0;

							// Show progress modal
							const progressModal = Modal.info({
								title: "Refreshing Data",
                                content: (
                                    <>
                                        <div>
                                            Found total {totalRows} feeds on amagi, refreshing each one by one with 1 minute delay to avoid rate limits
                                        </div>
                                        <div>
                                            Next feed refresh in:{" "}
                                            <Countdown value={Date.now() + 60000} format="mm:ss" />
                                        </div>
                                    </>
                                ),
								okButtonProps: { disabled: true },
							});

							// Process each row with a delay
							for (const row of data.feeds) {
								await new Promise(resolve => setTimeout(resolve, 60000)); // 1-minute delay
								const response = await authAxios({
									method: "GET",
									url: `${process.env.REACT_APP_BACK_END_API}/scheduling/amagi-segments/refresh-segments/${row.feed_id}`,
								});
								const data = await response.data;
								console.log("Data fetched successfully:", data);
								completedRows++;
								progressModal.update({
									content: (
										<>
											<div>
												Progress: {completedRows}/{totalRows} feeds done
											</div>
											<div>
												Next feed refresh in:{" "}
												<Countdown value={Date.now() + 60000} format="mm:ss" />
											</div>
										</>
									),
								});
							}

							// Update modal on completion
							progressModal.update({
								content: "All rows processed successfully!",
								okButtonProps: { disabled: false },
                                onOk: () => {
                                    // reload the page
                                    window.location.reload();
                                },
							});
						} catch (error) {
							Modal.error({
								title: "Error",
								content: "An error occurred while refreshing data.",
							});
						}
					},
				});
			}}
		>
			Amagi Cloudport - Refresh
		</Button>
	);
};

export default AmagiCloudPortRefreshDataButton;
